// Global guard for numeric inputs.
//
// `<input type="number">` natively accepts scientific notation ("1e5") and the
// sign characters "+"/"-". Every numeric field in this POS (prices, variant
// option prices, KDS second-thresholds, window sizes, years, quantities, hourly
// rates, usage limits, discount/adjustment values) is a non-negative amount, so
// "e", "E", "+" and "-" are never valid input. We block them in one delegated
// place so it also covers inputs injected at runtime (menu edit, discounts, etc).

const BLOCKED_KEYS = new Set(["e", "E", "+", "-"]);
const BLOCKED_PASTE = /[eE+-]/;

function isNumberInput(target) {
  return target instanceof HTMLInputElement && target.type === "number";
}

function onKeyDown(e) {
  if (!isNumberInput(e.target)) return;
  if (BLOCKED_KEYS.has(e.key)) e.preventDefault();
}

function onPaste(e) {
  if (!isNumberInput(e.target)) return;
  const text = (e.clipboardData || window.clipboardData)?.getData("text") ?? "";
  if (BLOCKED_PASTE.test(text)) e.preventDefault();
}

// Capture phase so this runs before any field-specific handlers.
document.addEventListener("keydown", onKeyDown, true);
document.addEventListener("paste", onPaste, true);
